export const currencyData = [
    {
        value: 'usd',
        symbol: '$',
    },
    {
        value: 'eur',
        symbol: '€',
    },
    {
        value: 'gbp',
        symbol: '£',
    },
];